import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuMultiSelectSearch } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectSearch';

export const SbSharedRefineMenuFilterMaterialComponent = props => (
    <SbSharedRefineMenuMultiSelectSearch {...props} />
);

export const SbSharedRefineMenuFilterMaterial = createFragmentContainer(
    SbSharedRefineMenuFilterMaterialComponent,
    {
        viewer: graphql`
            fragment SbSharedRefineMenuFilterMaterial_viewer on Viewer {
                ...SbSharedRefineMenuMultiSelectSearch_viewer
            }
        `,
        searchBrowse: graphql`
            fragment SbSharedRefineMenuFilterMaterial_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuMultiSelectSearch_searchBrowse
            }
        `,
    }
);
